import { MultiInputsTransformConvertor } from './multiInputsTransform.convertor';
import { LookupPlainObject } from 'worker/app-workers/shared/plainObjects/lookup.plainObject';
import { Transformation } from 'app/model/dataflow/transformation';
import { DataFlowExpressionUtils } from '../../expression.util';
import { LookupTransformation } from 'app/model/dataflow/lookuptransformation';
import { StringDataFlowType, BooleanDataFlowType } from 'app/model/dataflow/dataflow-datatype';
import { IResourceContext } from 'shell-models-lib';

export class LookupConvertor extends MultiInputsTransformConvertor {
    private get lookupTransform(): LookupTransformation {
        return this.transformation as LookupTransformation;
    }

    private get lookupObject(): LookupPlainObject {
        return this.transformObject as LookupPlainObject;
    }

    public async convert(contextData: IResourceContext): Promise<Transformation> {
        await super.convert(contextData);

        this.lookupObject.sortExpressions.forEach((sortExpression) => {
            const expression = this.lookupTransform.addSortExpression();
            expression.dataFlowExpression.expression = DataFlowExpressionUtils.unwrapExpressionWithEmptyValue(
                sortExpression.expression
            );
            expression.ascending = sortExpression.ascending;
            expression.nullsFirst = sortExpression.nullsFirst;
        });

        this.lookupTransform.multipleRow.expression = 'true';

        this.lookupObject.configs.forEach((expression, configName) => {
            if (configName === 'multiple') {
                this.lookupTransform.multipleRow = DataFlowExpressionUtils.unwrapExpressionConfigValue(
                    expression,
                    this.lookupTransform,
                    BooleanDataFlowType.TYPE
                );
                this._handledConfigs.push(configName);
            } else if (configName === 'pickup') {
                this.lookupTransform.pickupRow = DataFlowExpressionUtils.unwrapExpressionConfigValue(
                    expression,
                    this.lookupTransform,
                    StringDataFlowType.TYPE
                );
                this._handledConfigs.push(configName);
            }
        });

        super.postConvert();
        return this.transformation;
    }
}
